import { clamp } from "@suse-o11y/clamp";
import { min } from "@suse-o11y/min";

const BORDER_WIDTH_COEFFICIENT = 0.0055;
const BORDER_WIDTH_MIN_PX = 0;
const BORDER_WIDTH_MAX_PX = 2;

const BORDER_RADIUS_COEFFICIENT = 0.015;
const BORDER_RADIUS_MIN_PX = 0;
const BORDER_RADIUS_MAX_PX = 5;

export function autoBorderWidth(width: number, height: number): number {
	return clamp(min(width, height) * BORDER_WIDTH_COEFFICIENT, { min: BORDER_WIDTH_MIN_PX, max: BORDER_WIDTH_MAX_PX });
}

export function autoBorderRadius(width: number, height: number): number {
	return clamp(min(width, height) * BORDER_RADIUS_COEFFICIENT, {
		min: BORDER_RADIUS_MIN_PX,
		max: BORDER_RADIUS_MAX_PX,
	});
}

export const ALL_PIE_CHART_TYPES = ["pie", "donut"] as const;

export type PieChartType = (typeof ALL_PIE_CHART_TYPES)[number];

const DONUT_INNER_RADIUS_PERCENT = "55%";
const OUTER_RADIUS_PERCENT = "100%";

export function toRadius(type: PieChartType): string | [string, string] {
	return type === "donut" ? [DONUT_INNER_RADIUS_PERCENT, OUTER_RADIUS_PERCENT] : OUTER_RADIUS_PERCENT;
}
